import Vue from "vue";

import "normalize.css/normalize.css"; // 替代CSS重置

import "@utils/element-ues"; // 按需引入ElementUI,若有缺少，自行添加

import "@assets/styles/index.scss"; // 全局引用样式

import App from "./App.vue";
import router from "./router";
import store from "./store";

import './permission' // 权限控制
import _ from "lodash"; // JavaScript 实用工具库
import * as filters from "@/filters"; // 全局过滤器
import * as directives from "./directives"; // 全局过指令
// import * as echarts from "echarts"; //图表

//百度编辑器
import "../lib/ueditor/ueditor.config.js";
import "../lib/ueditor/ueditor.all.min.js";
import "../lib/ueditor/lang/zh-cn/zh-cn.js";
import "../lib/ueditor/ueditor.parse.min.js";

// 按钮添加防抖节流
import '@/utils/button'

// lodash挂载
// Vue.prototype.$echarts = echarts; // 全局引用图表
// 自定义横向拖动指令
import dragDirective from "./directives/dragDirective.js";
Vue.directive('drag', dragDirective);


// 回到顶部
import BackToTop from './components/backToTop.vue';
Vue.component('BackToTop', BackToTop);
// 反馈
import feedback from './components/feedback.vue';
Vue.component('feedback', feedback);


// 个人信息
import avatarTop from './components/avatar.vue';
Vue.component('avatarTop', avatarTop);

// 语言包
import VueI18n from 'vue-i18n';
import messages from './locales'; // 导入语言包

// 数字渐变
import CountTo from 'vue-count-to';
Vue.component('count-to', CountTo);

// 图片裁剪
import VueCropper from 'vue-cropper'
Vue.use(VueCropper)

// 
import {jumpLogin,navigateParams, navigate,externalTo,erroravatarHandler,formatTime,validTelHide,validEmailHide,jumpLink } from "@utils";
import {encryptByDES,encryptByAES, decryptByAES,decryptByDES } from "@utils";


Vue.prototype.$encryptByAES = encryptByAES;
Vue.prototype.$decryptByAES = decryptByAES;
Vue.prototype.$decryptByDES = decryptByDES;
Vue.prototype.$encryptByDES = encryptByDES;

Vue.prototype.$navigate = navigate;
Vue.prototype.$navigateParams = navigateParams;
Vue.prototype.$externalto = externalTo;
Vue.prototype.$erroravatarHandler = erroravatarHandler;
Vue.prototype.formatTime = formatTime;
Vue.prototype.$jumpLogin = jumpLogin;

Vue.prototype.$validTelHide = validTelHide;
Vue.prototype.$validEmailHide = validEmailHide;
Vue.prototype.$jumpLink = jumpLink;

// // 富文本
// import tinymce from 'tinymce';
// Vue.prototype.$tinymce = tinymce;


Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'zh', // 设置默认语言
  messages, // 设置语言包
});

Vue.use(i18n);

// 创建事件总线
Vue.prototype.$bus = new Vue();



import VueAwesomeSwiper from 'vue-awesome-swiper';
Vue.use(VueAwesomeSwiper);
// 注册全局过滤器
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

// 注册全局过指令
Object.keys(directives).forEach((key) => {
  Vue.use(directives[key]);
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");

